import {
  SupportData,
  BrandNumbers,
  IntegrationNumbers,
  Links,
  NormalizedSupportLink,
} from 'data/types/support';
import formatPhoneNumber from 'utils/formatPhoneNumber';

export const normalizeBrandNumbers = (data: BrandNumbers) => {
  return {
    id: data.brandId,
    phoneNumber: formatPhoneNumber(data.phoneNumber),
  };
};

export const normalizeIntegrationNumbers = (data: IntegrationNumbers) => {
  return {
    id: data.integrationId,
    phoneNumber: formatPhoneNumber(data.phoneNumber),
    icon: data.icon,
  };
};

export const normalizeSupportLinks = (data: Links): NormalizedSupportLink => {
  return {
    name: data.linkName.displayName,
    id: data.linkName.linkId,
    url: data.link,
  };
};

export const normalizeSupport = (data: SupportData) => {
  return {
    brandNumbers: data.brandNumbers.map(normalizeBrandNumbers),
    integrationNumbers: data.integrationNumbers.map(
      normalizeIntegrationNumbers,
    ),
    supportLinks: data.supportLinks.map(normalizeSupportLinks),
  };
};

export type Support = ReturnType<typeof normalizeSupport>;
